import { action, computed, observable } from 'mobx';

import { getCartSamples } from '~api/CartAPI/CartAPIs';

import { ICartItem } from '~api/CartAPI/ICartAPIs';

export class CartRepository {
    @observable private _samplesInCart: ICartItem[] = [];
    @observable private _isLoading: boolean = false;

    constructor() {
        this.getCart();
    }

    @action public getCart = async () => {
        this._isLoading = true;
        this._samplesInCart = await getCartSamples();
        this._isLoading = false;

        return this._samplesInCart;
    };

    @action public setSamplesInCart = (samples: ICartItem[]) => {
        this._samplesInCart = samples;
    };

    @computed public get isLoading() {
        return this._isLoading;
    }

    @computed public get samplesInCart() {
        return this._samplesInCart;
    }
}
